import React, { useMemo } from 'react'
import { FieldProps } from 'formik'
import { getCodeMapOptions } from 'share/util/common'
import { CodeMap } from 'adminConsole/page'

export type SelectCodeMapFieldProps = {
  label?: string
  category: string
  codeMapList: CodeMap[]
  isFilterEnable?: boolean
  reserve1?: string
  placeholder?: string
  required?: boolean
}

type Props = SelectCodeMapFieldProps & FieldProps

export const SelectCodeMapField: React.FC<Props> = ({
  label,
  category,
  codeMapList,
  isFilterEnable = true,
  reserve1,
  placeholder = '請選擇',
  required = false,
  field,
  form: { touched, errors },
}) => {
  const options = useMemo(() => {
    const filtered = getCodeMapOptions(codeMapList, category, isFilterEnable, reserve1)

    return filtered
  }, [codeMapList, category, isFilterEnable, reserve1])

  const hasError = touched[field.name] && errors[field.name]

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={field.name}>
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <select {...field} id={field.name} className={`form-control ${hasError ? 'is-invalid' : ''}`}>
        <option value="">{placeholder}</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {hasError && (
        <div className="invalid-feedback" style={{ display: 'block' }}>
          {errors[field.name]}
        </div>
      )}
    </div>
  )
}
